import { ChevronDown } from "react-feather";
import styles from "../communication-chat.module.css";
import { useEffect, useState } from "react";
import moment from "moment";

const ProspectListunread = (props) => {
  const [prospectUnreadMessages, SetProspectUnreadMessages] = useState([]);
  const [unreadMessageCounter, setUnreadMessageCounter] = useState(0);

  useEffect(() => {
    const prospects = props.unreadMessageList
      .filter((p) => p.type === "Prospect" && (p.message || p.unread_no > 0))
      .sort((a, b) => {
        const unreadA = a.unread_no > 0 ? 1 : 0;
        const unreadB = b.unread_no > 0 ? 1 : 0;

        // Prioritize unread messages first
        if (unreadA !== unreadB) {
          return unreadB - unreadA; // Unread messages come first
        }

        // If both are in the same group (both read or both unread), sort by message_time
        const timeA = a.message_time ? new Date(a.message_time).getTime() : 0;
        const timeB = b.message_time ? new Date(b.message_time).getTime() : 0;

        return timeB - timeA; // Latest message first
      });

    SetProspectUnreadMessages(prospects);

    const totalUnread = prospects.reduce((acc, message) => {
      return acc + message.unread_no;
    }, 0);

    setUnreadMessageCounter(totalUnread);
  }, [props]);

  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : "";
    const last = lastName ? lastName.charAt(0).toUpperCase() : "";
    return first + last || "?";
  };

  const getAvatarUrl = (user_avatar) => {
    if (!user_avatar || user_avatar === "") return null;
    return `${process.env.REACT_APP_PROSPECT_TENANT_IMAGE_BASE_URL}${user_avatar}`;
  };

  // Function to format phone number
  const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return cleaned;
  };

  return (
    <>
      <div
        onClick={() => props.toggleAccordionForProspectUnRead()}
        className={
          props.accordionOnForProspectUnRead
            ? `${styles.accordionOn} ${styles.Open}`
            : `${styles.accordionOn}`
        }
      >
        <p className={`${styles.ListAccoudionTitle}`}>
          <ChevronDown /> Prospects <span>{unreadMessageCounter}</span>
        </p>
        {prospectUnreadMessages.length > 0 &&
          prospectUnreadMessages.map((prospect, i) => {
            return (
              <div key={i}>
                <div
                  className={
                    prospect.id === props?.prospectTenantDetails?.id
                      ? `${styles.activeTenant} ${styles.CommuListSecMessage}`
                      : `${styles.CommuListSecMessage}`
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setDetails(prospect);
                  }}
                >
                  <div className={`${styles.EmployeeAvatarSec}`}>
                    {getAvatarUrl(prospect?.user_avatar) ? (
                      <img
                        src={getAvatarUrl(prospect.user_avatar)}
                        alt=""
                        className={`${styles.EmpAvatarImg}`}
                      />
                    ) : (
                      <p className={`${styles.EmpAvatarInitials}`}>
                        {getInitials(
                          prospect?.first_name,
                          prospect?.last_name
                        )}
                      </p>
                    )}
                  </div>
                  <div className={`${styles.ConSecCus}`}>
                    <div className={`${styles.EmployeeListDeSec}`}>                    
                      <div className={`${styles.CommuListDeSec}`}>
                        <p className={`${styles.ProsTenantList}`}>
                          {prospect?.first_name && (
                            <span>
                              {prospect?.first_name}&nbsp;{prospect?.last_name}
                            </span>
                          )}
                          {!prospect?.first_name && (
                            <span>{formatPhoneNumber(prospect?.phone)}</span>
                          )}
                        </p>
                      </div>
                    </div>
                    {prospect?.message && (
                      <div className={`${styles.CommuListStatusSec}`}>
                        <p className={`${styles.UnreadMessageTime}`}>
                          {moment(prospect?.message_time).fromNow()}
                        </p>
                      </div>
                    )}
                    {prospect?.message && (
                      <div className={`${styles.UnreadMsgSec}`}>
                        <p
                          className={
                            prospect?.unread_no > 0 &&
                            !prospect?.message.startsWith("You:")
                              ? `${styles.UnreadMessage} ${styles.Unread}`
                              : `${styles.UnreadMessage}`
                          }
                        >
                          {prospect?.message}
                        </p>
                      </div>
                    )}
                    {prospect?.unread_no > 0 && (
                      <div className={`${styles.UnreadMsgCountSec}`}>
                        <span className={`${styles.PropertyGroupNotiCount}`}>
                          {prospect?.unread_no}
                        </span>
                      </div>
                    )}
                    {!prospect?.message && (
                      <div className={`${styles.UnreadMsgSec}`}>
                        <p className={`${styles.CommounMsg}`}>--</p>
                      </div>
                    )}
                    {/* {prospect?.message && <div>
                    <div>{prospect?.message}</div>
                    <div>{moment(prospect?.message_time).fromNow()}</div>
                    </div>} */}
                  </div>
                  
                </div>

                {/* <p
                  className={
                    prospect.id === props?.prospectTenantDetails?.id
                      ? `${styles.activeTenant} ${styles.ProsTenantList}`
                      : `${styles.ProsTenantList}`
                  }
                >
                  {prospect?.first_name && (
                    <span className={`${styles.Name}`}>
                      {prospect?.first_name}&nbsp;{prospect?.last_name}
                    </span>
                  )}{" "}
                  <span className={`${styles.Phone}`}>
                    {formatPhoneNumber(prospect?.phone)}
                  </span>
                </p> */}
              </div>
            );
          })}
        {prospectUnreadMessages.length === 0 && (
          <div className={`${styles.NoDataSecOnlyText}`}>
            <img src="/static/img/chatIcon.png" alt="" />
            <p>No prospect here!</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ProspectListunread;
